export default __webpack_public_path__ + "static/mike-grabowsky-4bf12404f31d6a9b3944982de1eb5eb3.jpg";